import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  FormGroup,
  FormField,
  TextArea
} from 'semantic-ui-react'

const CardTreatmentResultUX = (props: any) => {
    return(
      <div>
        <div
          id="CardTreatmentResult-Div-TreatmentResultScreen"
          style={{padding: "10px 10px 0px 10px", fontSize: "1.4rem", fontWeight: "bold" ,display: "flex", alignItems: "center" }}>
          
          <div
            id="CardTreatmentResultUX-div-4">
            {props.languageUX === "en" ? "Record of surgical results" : "บันทึกผลหัตถการ"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardTreatmentResultUX-div-6"
          style={{marginRight:"10px", marginLeft:"10px"}}>
          
        </div>
        <div
          id="CardTreatmentResultUX-div-7"
          style={{padding:"10px"}}>
          
          <Table
            data={props.dataTreatment}
            getTrProps={props.rowProps}
            headers="รายละเอียดคำสั่งหัตถการ,Care provider,สถานะ,ผู้ทำหัตถการ"
            id="CardTreatmentResultUX-Table-8"
            keys="order_detail,careprovider,status_name,treatmen_name"
            minRows={4}
            showPagination={false}
            style={{height: "250px"}}
            widths="^250,^150,^100,^150">
          </Table>
        </div>
        <div
          className="ui divider"
          id="CardTreatmentResultUX-div-9"
          style={{marginRight:"10px", marginLeft:"10px"}}>
          
        </div>
        <div
          id="CardTreatmentResultUX-div-10"
          style={{padding: "0px 10px 0px 10px", fontSize: "1.4rem", fontWeight: "bold" ,display: props.hideDescription ? "none":"flex", alignItems: "center",  }}>
          {props.languageUX === "en" ? "Principal" : "Principal"}
        </div>
        <div
          id="CardTreatmentResultUX-div-11"
          style={{position: "relative",display: props.hideDescription ? "none":""}}>
          
          <div
            id="CardTreatmentResultUX-div-12"
            style={{padding: "10px 10px 0px 10px"}}>
            {props?.diagnosisListPrincipal}
          </div>
          <div
            id="CardTreatmentResultUX-div-92"
            style={{display: props?.showSearchResultPrincipal ? "" : "none", position: "absolute", zIndex: 100, width: "80%", height: "400px" }}>
            
          </div>
          <div
            id="CardTreatmentResultUX-div-13"
            style={{padding: "10px 10px 0px 10px" ,display:"flex"}}>
            
            <div
              id="CardTreatmentResultUX-div-15">
              
              <Button
                color="green"
                id="CardTreatmentResult-Button-AddPrincipal"
                onClick={props.OnaddPrincipal}>
                {props.languageUX === "en" ? "+ Principal" : "+ ผู้อำนวยการ"}
              </Button>
            </div>
            <div
              id="CardTreatmentResultUX-div-16"
              style={{display: props.isShowDiagnosisSecondary ? "none" : ""}}>
              
              <Button
                color="yellow"
                id="CardTreatmentResult-Button-AddSecondary-1"
                onClick={props.OnaddSecondary}>
                {props.languageUX === "en" ? "+ Secondary" : "+ รอง"}
              </Button>
            </div>
          </div>
          <div
            id="CardTreatmentResultUX-div-14"
            style={{padding: "10px 10px 0px 10px",display: props.isShowDiagnosisSecondary ? "" : "none"}  }>
            
            <div
              className="ui divider"
              id="CardTreatmentResultUX-div-20">
              
            </div>
            <div
              id="CardTreatmentResultUX-div-19"
              style={{fontSize: "1.4rem", fontWeight: "bold" ,display: "flex", alignItems: "center"}}>
              {props.languageUX === "en" ? "Secondary" : "มัธยมศึกษาตอนปลาย"}
            </div>
            <div
              id="CardTreatmentResultUX-div-21">
              {props?.diagnosisListSecondary}
            </div>
            <div
              id="CardTreatmentResultUX-div-94"
              style={{display: props?.showSearchResultSecondary ? "" : "none", position: "absolute", zIndex: 100, width: "80%", height: "400px" }}>
              
            </div>
            <div
              id="CardTreatmentResultUX-div-22"
              style={{marginTop:"10px"}}>
              
              <Button
                color="yellow"
                id="CardTreatmentResult-Button-AddSecondary-2"
                onClick={props.OnaddSecondary}>
                {props.languageUX === "en" ? "+ Secondary" : "+ รอง"}
              </Button>
            </div>
            <div
              className="ui divider"
              id="CardTreatmentResultUX-div-23">
              
            </div>
          </div>
        </div>
        <div
          id="CardTreatmentResultUX-div-64"
          style={{padding: "10px 10px 0px 10px",display: props.hideDescription ? "none":""}}>
          
          <div
            id="CardTreatmentResultUX-div-91">
            {props?.ErrorMessage}
          </div>
          <div
            className="ui form"
            id="CardTreatmentResultUX-div-102">
            
            <FormGroup
              id="CardTreatmentResultUX-FormGroup-103"
              inline={true}
              style={{alignItems:"baseline"}}
              widths={16}>
              <FormField
                id="CardTreatmentResultUX-FormField-106"
                inline={true}
                style={{alignItems:"baseline"}}
                width={2}>
                <label
                  id="CardTreatmentResultUX-label-119"
                  style={{fontWeight: "bold",fontSize: "1.3rem"}}>
                  {props.languageUX === "en" ? "Record results :" : "บันทึกผล :"}
                </label>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-108"
                inline={true}
                style={{alignItems:"baseline"}}
                width={8}>
                <label
                  id="CardTreatmentResultUX-label-126"
                  style={{fontWeight:"bold", fontSize:"1rem"}}>
                  {props.languageUX === "en" ? "Details of the surgical order:" : "รายละเอียดคำสั่งหัตถการ:"}
                </label>
                <div
                  id="CardTreatmentResultUX-div-121">
                  {props?.treatmentRow?.order_detail_header}
                </div>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-124"
                inline={true}
                style={{alignItems:"baseline"}}
                width={6}>
                <label
                  id="CardTreatmentResultUX-label-127"
                  style={{fontWeight:"bold", fontSize:"1rem"}}>
                   รายละเอียดอุปกรณ์:
                </label>
                <div
                  id="CardTreatmentResultUX-div-125">
                  {props?.treatmentRow?.equipment_detail}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTreatmentResultUX-FormGroup-104"
              inline={true}
              widths={16}>
              <FormField
                className="required"
                id="CardTreatmentResultUX-FormField-111"
                inline={true}
                width={2}>
                <label
                  id="CardTreatmentResultUX-label-128"
                  style={{fontWeight:"bold", fontSize:"1rem", }}>
                  {props.languageUX === "en" ? "Date and time of commencement of procedure:" : "วันเวลาการเริ่มทำหัตถการ:"}
                </label>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-112"
                inline={true}
                width={2}>
                <div
                  id="CardTreatmentResultUX-div-130"
                  style={{width:"100%", marginBottom:"-5px"}}>
                  {props?.StartTime}
                </div>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-113"
                inline={true}>
                <div
                  id="CardTreatmentResultUX-div-131">
                  {props.StartDateElement}
                </div>
              </FormField>
              <FormField
                className="required"
                id="CardTreatmentResultUX-FormField-114"
                inline={true}>
                <label
                  id="CardTreatmentResultUX-label-129"
                  style={{fontWeight:"bold", fontSize:"1rem"}}>
                  {props.languageUX === "en" ? "End date of procedure:" : "วันเวลาสิ้นสุดการทำหัตถการ :"}
                </label>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-115"
                inline={true}
                width={2}>
                <div
                  id="CardTreatmentResultUX-div-132"
                  style={{width:"100%", marginBottom:"-5px"}}>
                  {props?.FinishTime}
                </div>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-133"
                inline={true}>
                <div
                  id="CardTreatmentResultUX-div-134">
                  {props.FinishDateElement}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardTreatmentResultUX-FormGroup-105"
              inline={true}
              style={{alignItems:"flex-start"}}
              widths={16}>
              <FormField
                id="CardTreatmentResultUX-FormField-116"
                width={2}>
                <label
                  id="CardTreatmentResultUX-label-136"
                  style={{fontWeight:"bold", fontSize:"1rem", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "details :" : "รายละเอียด :"}
                </label>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-117"
                width={6}>
                <TextArea
                  id="CardTreatmentResult-TextArea-OrderDetail"
                  name="result"
                  onChange={props.handleChangeResult}
                  value={props?.result}>
                </TextArea>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-118"
                width={2}>
                <label
                  id="CardTreatmentResultUX-label-137"
                  style={{fontWeight:"bold", fontSize:"1rem", textAlign:"right", minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Complications :" : "ภาวะแทรกซ้อน :"}
                </label>
              </FormField>
              <FormField
                id="CardTreatmentResultUX-FormField-135"
                width={6}>
                <TextArea
                  id="CardTreatmentResult-TextArea-Complications"
                  name="complications"
                  onChange={props.handleChangeResult}
                  value={props?.complications}>
                </TextArea>
              </FormField>
            </FormGroup>
          </div>
        </div>
        <div
          id="CardTreatmentResultUX-div-51"
          style={{paddingTop: "20px ",display: props.hideDescription ? "none":"flex", alignItems:"center"}}>
          
          <div
            id="CardTreatmentResultUX-div-58"
            style={{flex:"1"}}>
            
          </div>
          <div
            id="CardTreatmentResultUX-div-63"
            style={{ fontWeight: "bold" ,display: props.hideCode ? "none" : "flex", alignItems: "center",marginRight:"7px"}}>
            {props.languageUX === "en" ? "Operator Code" : "รหัสผู้ทำหัตถการ"}
            <label
              id="CardTreatmentResultUX-label-140"
              style={{color: "#db2828", marginLeft: "0.25rem"}}>
              *
            </label>
          </div>
          <div
            id="CardTreatmentResultUX-div-59"
            style={{ display: props.hideCode ? "none" : "flex" }}>
            {props?.code}
          </div>
          <div
            id="CardTreatmentResultUX-div-95">
            {props.buttonEditOrder}
          </div>
          <div
            id="CardTreatmentResultUX-div-96">
            {props.buttonSaveOrder}
          </div>
          <div
            id="CardTreatmentResultUX-div-97">
            {props.buttonConfirmOrder}
          </div>
          <div
            id="CardTreatmentResultUX-div-98">
            {props.buttonCancelOrder}
          </div>
        </div>
        <div
          id="CardTreatmentResultUX-div-87"
          style={{padding: "10px ",display: props.hideDescription ? "none":"flex"}}>
          
        </div>
      </div>
    )
}


export default CardTreatmentResultUX

export const screenPropsDefault = {}

/* Date Time : Thu Feb 19 2026 16:50:50 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-Div-TreatmentResultScreen"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\", fontSize: \"1.4rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกผลหัตถการ",
          "valueEN": "Record of surgical results"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-4"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\", marginLeft:\"10px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{padding:\"10px\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 8,
      "name": "Table",
      "parent": 7,
      "props": {
        "data": {
          "type": "code",
          "value": "props.dataTreatment"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "value",
          "value": "รายละเอียดคำสั่งหัตถการ,Care provider,สถานะ,ผู้ทำหัตถการ"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-Table-8"
        },
        "keys": {
          "type": "value",
          "value": "order_detail,careprovider,status_name,treatmen_name"
        },
        "minRows": {
          "type": "code",
          "value": "4"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"250px\"}"
        },
        "widths": {
          "type": "value",
          "value": "^250,^150,^100,^150"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{marginRight:\"10px\", marginLeft:\"10px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Principal",
          "valueEN": "Principal"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 0px 10px\", fontSize: \"1.4rem\", fontWeight: \"bold\" ,display: props.hideDescription ? \"none\":\"flex\", alignItems: \"center\",  }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{position: \"relative\",display: props.hideDescription ? \"none\":\"\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.diagnosisListPrincipal"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\" ,display:\"flex\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\",display: props.isShowDiagnosisSecondary ? \"\" : \"none\"}  "
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-15"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{display: props.isShowDiagnosisSecondary ? \"none\" : \"\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Button",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "+ ผู้อำนวยการ",
          "valueEN": "+ Principal"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-Button-AddPrincipal"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnaddPrincipal"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 18,
      "name": "Button",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "+ รอง",
          "valueEN": "+ Secondary"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-Button-AddSecondary-1"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnaddSecondary"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "มัธยมศึกษาตอนปลาย",
          "valueEN": "Secondary"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.4rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-20"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.diagnosisListSecondary"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-21"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{marginTop:\"10px\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-23"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Button",
      "parent": 22,
      "props": {
        "children": {
          "type": "value",
          "value": "+ รอง",
          "valueEN": "+ Secondary"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-Button-AddSecondary-2"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnaddSecondary"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{paddingTop: \"20px \",display: props.hideDescription ? \"none\":\"flex\", alignItems:\"center\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{flex:\"1\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.code"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.hideCode ? \"none\" : \"flex\" }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัสผู้ทำหัตถการ",
          "valueEN": "Operator Code"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-63"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,display: props.hideCode ? \"none\" : \"flex\", alignItems: \"center\",marginRight:\"7px\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-64"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 0px 10px\",display: props.hideDescription ? \"none\":\"\"}"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px \",display: props.hideDescription ? \"none\":\"flex\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.ErrorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-91"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{display: props?.showSearchResultPrincipal ? \"\" : \"none\", position: \"absolute\", zIndex: 100, width: \"80%\", height: \"400px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{display: props?.showSearchResultSecondary ? \"\" : \"none\", position: \"absolute\", zIndex: 100, width: \"80%\", height: \"400px\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonEditOrder"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-95"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSaveOrder"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirmOrder"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-97"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonCancelOrder"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-98"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 64,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-102"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "FormGroup",
      "parent": 102,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormGroup-103"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"baseline\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "FormGroup",
      "parent": 102,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormGroup-104"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "FormGroup",
      "parent": 102,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormGroup-105"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"flex-start\"}"
        },
        "widths": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "FormField",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-106"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"baseline\"}"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-108"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"baseline\"}"
        },
        "width": {
          "type": "code",
          "value": "8"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "FormField",
      "parent": 104,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-111"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 112,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-112"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-113"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "FormField",
      "parent": 104,
      "props": {
        "className": {
          "type": "value",
          "value": "required"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-114"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-115"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 116,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-116"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 117,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-117"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 118,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-118"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "label",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกผล :",
          "valueEN": "Record results :"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-119"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\",fontSize: \"1.3rem\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.treatmentRow?.order_detail_header"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-121"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 124,
      "name": "FormField",
      "parent": 103,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-124"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{alignItems:\"baseline\"}"
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 124,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.treatmentRow?.equipment_detail"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-125"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "label",
      "parent": 108,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดคำสั่งหัตถการ:",
          "valueEN": "Details of the surgical order:"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-126"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "label",
      "parent": 124,
      "props": {
        "children": {
          "type": "value",
          "value": " รายละเอียดอุปกรณ์:"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-127"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "label",
      "parent": 111,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาการเริ่มทำหัตถการ:",
          "valueEN": "Date and time of commencement of procedure:"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-128"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\", }"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "label",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": "วันเวลาสิ้นสุดการทำหัตถการ :",
          "valueEN": "End date of procedure:"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-129"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\"}"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 112,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.StartTime"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", marginBottom:\"-5px\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDateElement"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-131"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 115,
      "props": {
        "children": {
          "type": "code",
          "value": "props?.FinishTime"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-132"
        },
        "style": {
          "type": "code",
          "value": "{width:\"100%\", marginBottom:\"-5px\"}"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 133,
      "name": "FormField",
      "parent": 104,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-133"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 133,
      "props": {
        "children": {
          "type": "code",
          "value": "props.FinishDateElement"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-div-134"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 135,
      "name": "FormField",
      "parent": 105,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-FormField-135"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "6"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "label",
      "parent": 116,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียด :",
          "valueEN": "details :"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-136"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\", minWidth: \"max-content\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "label",
      "parent": 118,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาวะแทรกซ้อน :",
          "valueEN": "Complications :"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-137"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bold\", fontSize:\"1rem\", textAlign:\"right\", minWidth: \"max-content\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 138,
      "name": "TextArea",
      "parent": 117,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-TextArea-OrderDetail"
        },
        "name": {
          "type": "value",
          "value": "result"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeResult"
        },
        "value": {
          "type": "code",
          "value": "props?.result"
        }
      },
      "seq": 138,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 139,
      "name": "TextArea",
      "parent": 135,
      "props": {
        "id": {
          "type": "value",
          "value": "CardTreatmentResult-TextArea-Complications"
        },
        "name": {
          "type": "value",
          "value": "complications"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeResult"
        },
        "value": {
          "type": "code",
          "value": "props?.complications"
        }
      },
      "seq": 139,
      "void": true
    },
    {
      "from": null,
      "id": 140,
      "name": "label",
      "parent": 63,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardTreatmentResultUX-label-140"
        },
        "style": {
          "type": "code",
          "value": "{color: \"#db2828\", marginLeft: \"0.25rem\"}"
        }
      },
      "seq": 140,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 100,
  "isMounted": false,
  "memo": false,
  "name": "CardTreatmentResultUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 90
}

*********************************************************************************** */
